import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const duesRecipientsKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'duesRecipients'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
      }),
  });
};

export { duesRecipientsKeys };
